import MainLayout from '../layouts/main';
import TermsAndConditions from './terms-and-conditions';

function TermsAndConditionsPage() {
  return (
    <MainLayout
      loginRequired={false}
      studentRequired={false}
      title={TERMS_AND_CONDITIONS_PAGE_TITLE}
    >
      <TermsAndConditions />
    </MainLayout>
  );
}

export const TERMS_AND_CONDITIONS_PAGE_TITLE = 'شرایط و قوانین';

export default TermsAndConditionsPage;
